import { Dataset } from '../../types/types';
import { DATASET_ITEM_VISIBILITY_KEYS } from '../../constants';
import { hasDynamicItemVisibility } from './hasDynamicItemVisibility';

// Mirrors forms' getInitialVisibility: expression items stay hidden until resolved
export const getDatasetWithInitialVisibility = (dataset: Dataset): Dataset => {
  if (!hasDynamicItemVisibility(dataset)) {
    return dataset;
  }

  const items = (dataset.items ?? []).map((item) => {
    const expressionKeys = DATASET_ITEM_VISIBILITY_KEYS.filter(
      (key) => typeof item[key] === 'string'
    );
    if (!expressionKeys.length) {
      return item;
    }

    const hiddenItem = { ...item };
    expressionKeys.forEach((key) => {
      hiddenItem[key] = false;
    });
    return hiddenItem;
  });

  return { ...dataset, items };
};
